import type { RetentionPeriod } from "@octopusdeploy/octopus-server-client";
const policySummary = (policy: RetentionPeriod): string => {
    switch (policy.Strategy) {
        case "Count":
            switch (policy.Unit) {
                case "Days":
                    return policy.QuantityToKeep === 1 ? "Keep 1 day" : "Keep " + policy.QuantityToKeep + " days";
                case "Items":
                default:
                    return policy.QuantityToKeep === 1 ? "Keep 1 release" : "Keep " + policy.QuantityToKeep + " releases";
            }
        case "Forever":
            return "Keep all";
        case "Default":
        default:
            return "Use default policy";
    }
};
export default policySummary;
